import { useContext } from 'react';
import '../state/constants.js';
import { setValue, saveOneFilter } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';

const CustomControl = ({
  onRender
}) => {
  const {
    state,
    dispatch
  } = useContext(FilterPanelContext);
  const setValue$1 = (field, value) => {
    dispatch(setValue(field, value));
  };
  const saveSingleFilter = field => {
    dispatch(saveOneFilter(field));
  };
  return onRender({
    setValue: setValue$1,
    saveSingleFilter,
    toBeAppliedFilters: state.toBeAppliedFilters,
    lastUpdatedElementId: state.lastUpdatedElementId
  });
};

export default CustomControl;
